import React, { useRef } from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import arrow from "../assets/images/icons/rightarrow.svg";
// import img1 from "../assets/images/img1.png";
// import img2 from "../assets/images/img2.png";
// import img3 from "../assets/images/img3.png";


// import img4 from "../assets/images/img4.png";

// import mp1 from "../assets/mp/img1.png";
import mp2 from "../assets/mp/img2.png";
import mp3 from "../assets/mp/img3.png";
import mp4 from "../assets/mp/img4.png";
import mp5 from "../assets/mp/img5.png";
// import mp6 from "../assets/mp/img6.png";
// import mp8 from "../assets/mp/img8.png";

const slides = [
  { img: mp2, desc: "Intelligent threat detection" },
  { img: mp3, desc: "Comprehensive protection" },
  { img: mp4, desc: "Robust data security" },
  { img: mp5, desc: "Cloud security solutions" },
  // { img: mp6, desc: "Secure access control" },
];

const AdvancedCarousel = () => {
  const carouselRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 1200,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1200,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="overflow-x-hidden pb-28 border-t-[#C09462] border-b-[#C09462] border-t-[1px] border-b-[1px]">
      <div className="container mx-auto px-4 md:px-0 mt-20">
        <h2 className="text-3xl md:text-5xl lg:text-[40px] text-center py-4">
          <p className="py-2">Multiple Pillars, One Vision</p>
          <p>
            MAXTRON <span>STRATEGY</span>
          </p>
        </h2>

        <p className="mt-6 text-[#808080] text-xl text-center">
          <span>Unwavering commitment. Global execution. Enduring impact.</span>
          <span className="block font-normal">
            MIF empowers startups and partners through venture acceleration,
            innovation capital, tokenization, and strategic alliances.
          </span>
        </p>

        <div className="block sm:flex justify-between mt-14">
          <button className="flex items-center text-2xl">
            WHAT WE DO
            <motion.img
              src={arrow}
              alt="arrow"
              className="ml-4"
              animate={{ x: [0, 10, 0] }}
              transition={{ duration: 1, repeat: Infinity }}
            />
          </button>

          <button className="flex items-center text-2xl mt-4 sm:mt-0">
            PARTNER WITH US
            <motion.img
              src={arrow}
              alt="arrow"
              className="ml-4"
              animate={{ x: [0, 10, 0] }}
              transition={{ duration: 1, repeat: Infinity }}
            />
          </button>
        </div>
      </div>

      <div className="mx-auto mt-10">
        <Slider {...settings} ref={carouselRef}>
          {slides.map((slide, index) => (
            <div key={index} className="p-4">
              <div className="">
                <img
                  src={slide.img}
                  alt={`Slide ${index + 1}`}
                  className="mx-auto mb-4 cursor-pointer w-[300px] h-[270px] object-cover"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default AdvancedCarousel;
